import { Backdrop, CircularProgress, Fade, makeStyles } from "@material-ui/core";
import { cloneElement, useCallback, useState } from "react";

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: theme.zIndex.snackbar + 1,
    },
    progress: {
        color: "#2FA52B",
    },
    itemContainer: {
        width: "100%",
        padding: "32px",

        [theme.breakpoints.down(500)]: {
            padding: "32px 16px",
        },
    },
}));

interface BlockingProgressProps {
    open: boolean;
    item: JSX.Element | null;
    callback?: () => void;
}

export const BlockingProgress = (props: BlockingProgressProps) => {
    const classes = useStyles();

    const { open, item, callback } = props;

    const [showingProgress, setShowingProgress] = useState(true);
    const onEnterProgress = useCallback(() => {
        setShowingProgress(true);
    }, []);
    const onExitedProgress = useCallback(() => {
        setShowingProgress(false);
    }, []);

    const onClose = useCallback(() => {
        if ( callback ) callback();
    }, [callback]);

    return (
        <Backdrop open={open} className={classes.root} onClick={onClose}>

            <Fade in={!item} timeout={200} onEntering={onEnterProgress} onExited={onExitedProgress} unmountOnExit>
                <CircularProgress className={classes.progress} />
            </Fade>
            
            {item && !showingProgress ? (
                <Fade in={!showingProgress} timeout={200}>
                    <div className={classes.itemContainer}>{cloneElement(item, { onClose })}</div>
                </Fade>
            ) : null}
        </Backdrop>
    );
};
